
document.addEventListener("DOMContentLoaded", function () {
  const pageContent = document.querySelector(".rte.wt-page__wrapper");

  if (!pageContent) return;

  pageContent.querySelectorAll("p").forEach((p) => {
    if (!p.querySelector("strong")) {
      p.style.marginLeft = "16px";
    } else {
      p.style.marginLeft = "0";
    }
  });
});